import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import { fetchUserProgress } from "../components/dataUtils";
import Swal from "sweetalert2"; // Added missing import

const registerGoogleUserViaNetlify = async ({ idToken, promocode }) => {
  // Existing code unchanged
  const response = await fetch("/.netlify/functions/registerGoogleUser", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ idToken, promocode }),
  });
  return response.json();
};

function GoogleUserModal({
  show,
  onHide,
  onSuccess,
  googleNewUser,
  setloggeduser,
  dispatch,
}) {
  const [promoCode, setPromoCode] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleGoogleUserModalSubmit = async () => {
    setError("");
    setIsSubmitting(true);

    try {
      // NEW: Confirm if promo code is empty
      if (!promoCode.trim()) {
        const result = await Swal.fire({
          title: "Promo Code",
          text: "Are you sure you want to proceed without entering a promo code?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
        });

        if (!result.isConfirmed) {
          setIsSubmitting(false);
          return;
        }
      }

      // Existing logic with trim added for consistency
      const promoToUse = promoCode.trim() === "" ? "DE100" : promoCode.trim();

      const idToken = await googleNewUser.getIdToken();
      const result = await registerGoogleUserViaNetlify({
        idToken,
        promocode: promoToUse,
      });

      if (!result.success) {
        setError(result.error || "Registration failed. Please try again.");
        setIsSubmitting(false);
        return;
      }

      // Rest of existing code unchanged
      window.localStorage.setItem("authCode", result.uid);
      window.localStorage.setItem("name", result.name);
      window.localStorage.setItem("userId", result.uid);
      setloggeduser(result.name);
      await fetchUserProgress(dispatch);
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("Error during Google user registration:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Rest of component unchanged
  return (
    <Modal show={show} onHide={onHide} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Welcome!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Please enter a promo code (if you have one) and confirm your name:
        </p>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your name"
              value={googleNewUser?.displayName || googleNewUser?.name || ""}
              readOnly
              disabled
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Promo Code</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter promo code"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              disabled={isSubmitting}
              autoComplete="off"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={handleGoogleUserModalSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                aria-hidden="true"
              />{" "}
              <span>Creating...</span>
            </>
          ) : (
            "Create Account"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

GoogleUserModal.propTypes = {
  // Existing propTypes unchanged
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  googleNewUser: PropTypes.shape({
    getIdToken: PropTypes.func.isRequired,
    displayName: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  setloggeduser: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default GoogleUserModal;
